/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasPathItem } from '../../models/OasPathItem';
import { OasPaths } from '../../models/OasPaths';
import { Oas30PathItem } from './Oas30PathItem';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasPaths
 */
export class Oas30Paths extends OasPaths {
    /**
     * @see io.apicurio.datamodels.openapi.models.OasPaths#createPathItem(java.lang.String)
     * @param {string} path
     * @return {OasPathItem}
     */
    public createPathItem(path : string) : OasPathItem {
        let pathItem : Oas30PathItem = new Oas30PathItem(path);
        pathItem._ownerDocument = this.ownerDocument();
        pathItem._parent = this;
        return pathItem;
    }

    constructor() {
        super();
    }
}
Oas30Paths["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Paths";
Oas30Paths["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];




